import { render, staticRenderFns } from "./BulletinBoard.vue?vue&type=template&id=dc189d86&scoped=true"
import script from "./BulletinBoard.vue?vue&type=script&lang=js"
export * from "./BulletinBoard.vue?vue&type=script&lang=js"
import style0 from "./BulletinBoard.vue?vue&type=style&index=0&id=dc189d86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc189d86",
  null
  
)

export default component.exports